<template>
  <div>
    <!-- 저장하기 버튼 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>
    <div v-if="value.social_key">
      <div class="columns is-multiline">
        <div class="column is-full">
          <div>
            <div>연동 계정 선택</div>
            <select v-model="selectedMenu">
              <option v-for="(item,idx) in menu" :key="'menu-option-'+idx" :value="item.value">{{ item.label }}</option>
            </select>
          </div>
        </div>
        <div class="column is-10-desktop is-full-tablet">
          <!-- 네이버 -->
          <template v-if="selectedMenu==='naver'">
            <div class="box" v-if="isInternalPlugin('sns_signin')">
              <admin-box-item title="네이버 계정 관리"
                              :useTab="false"
                              link="https://launchpack.notion.site/1725902f0f3a482aba234bd146d2e645">
                <div class="columns is-multiline">
                  <div class="column is-full">
                    <admin-form-item>
                      <a href="https://developers.naver.com/main/" target="_blank">
                        <div class="btn-link">Naver Developers 바로가기</div>
                      </a>
                    </admin-form-item>
                  </div>
                  <div class="column is-full">
                    <admin-form-item label="네이버 아이디로 로그인 API">
                      <div>
                        <lp-check-bool label="네이버 아이디로 로그인 사용"
                                       :checkedVal.sync="value.social_key.naver.enable.login"></lp-check-bool>
                      </div>
                    </admin-form-item>
                  </div>
                  <div class="column is-6">
                    <admin-form-item label="Client ID">
                      <input class="input"
                             :value="value.social_key.naver.client_id"
                             @input="e => value.social_key.naver.client_id = e.target.value"
                             type="text" maxlength="50">
                      <div class="desc">애플리케이션 정보에서 Client ID를 복사해서 붙여 넣어주세요.</div>
                    </admin-form-item>
                  </div>
                  <div class="column is-6">
                    <admin-form-item label="앱 시크릿 코드">
                      <input class="input"
                             :value="value.social_key.naver.client_secret"
                             @input="e => value.social_key.naver.client_secret = e.target.value"
                             type="text" maxlength="50">
                      <div class="desc">앱 시크릿 코드를 복사해서 붙여 넣어주세요.</div>
                    </admin-form-item>
                  </div>
                  <div class="column is-6">
                    <admin-form-item label="네이버 아이디로 로그인 Callback URL">
                      <input class="input"
                             :value="value.social_key.naver.redirect_url"
                             @input="e => value.social_key.naver.redirect_url = e.target.value"
                             type="text"
                             :disabled="true"
                             maxlength="50">
                      <div class="desc">네이버 아이디로 로그인 Callback URL에 위 주소를 붙여 넣어주세요.</div>
                    </admin-form-item>
                  </div>
                  <!--<div style="width:100%;height:1px;background-color:#dddddd;margin:12px 10px"></div>-->
                  <!--<div style="width:100%;height:1px;background-color:#dddddd;margin:12px 10px"></div>-->
                  <!--<div style="width:100%;height:1px;background-color:#dddddd;margin:12px 10px"></div>-->
                </div>
              </admin-box-item>
            </div>
            <div class="box">
              <admin-box-item title="네이버 지도 관리" :useTab="false" link="https://launchpack.notion.site/1725902f0f3a482aba234bd146d2e645#87206c5b83c647928cf8021a395b8775"
                              subtitle="네이버 지도 API를 연동할 수 있으며, 키값 미등록 시 파트너/상품 위치정보 전달 및 지도뷰 확인 사용이 불가합니다.">
                <div class="columns is-multiline">
                  <div class="column is-full">
                    <admin-form-item>
                      <a href="https://console.ncloud.com" target="_blank">
                        <div class="btn-link">Naver Cloud 바로가기</div>
                      </a>
                    </admin-form-item>
                  </div>
                  <div class="column is-full">
                    <admin-form-item label="네이버 지도">
                      <div>
                        <lp-radio :val.sync="value.social_key.naver.enable.map"
                                  value_name="value"
                                  label_name="label"
                                  :data="[{label:'지도 사용 안함', value:false}, {label:'지도 사용', value:true}]"></lp-radio>
                      </div>
                    </admin-form-item>
                  </div>
                  <div class="column is-6">
                    <admin-form-item label="Client ID">
                      <input class="input"
                             :value="value.social_key.naver.map.client_id"
                             @input="e => value.social_key.naver.map.client_id = e.target.value"
                             type="text" maxlength="50">
                      <div class="desc">애플리케이션 정보에서 Client ID를 복사해서 붙여 넣어주세요.</div>
                    </admin-form-item>
                  </div>
                  <div class="column is-6">
                    <admin-form-item label="앱 시크릿 코드">
                      <input class="input"
                             :value="value.social_key.naver.map.client_secret"
                             @input="e => value.social_key.naver.map.client_secret = e.target.value"
                             type="text" maxlength="50">
                      <div class="desc">앱 시크릿 코드를 복사해서 붙여 넣어주세요.</div>
                    </admin-form-item>
                  </div>
                </div>
              </admin-box-item>
            </div>
            <div class="box">
              <admin-box-item title="네이버 웹마스터 도구 관리" :useTab="false">
                <div class="columns is-multiline">
                  <div class="column is-full">
                    <admin-form-item>
                      <a href="https://searchadvisor.naver.com/" target="_blank">
                        <div class="btn-link">Naver Search Advisor 바로가기</div>
                      </a>
                    </admin-form-item>
                  </div>

                  <div class="column is-full">
                    <admin-form-item label="네이버 웹마스터 도구 Meta tag">
                      <input class="input"
                             :value="value.social_key.naver.verification"
                             @input="e => value.social_key.naver.verification = e.target.value"
                             type="text" maxlength="200">

                      <div class="desc">네이버 웹마스터 도구 설정에서 제공한 meta tag를 입력해주세요.</div>
                    </admin-form-item>
                  </div>
                </div>
              </admin-box-item>
            </div>
            <div class="box">
              <admin-box-item title="네이버 애널리틱스 관리" :useTab="false">
                <div class="columns is-multiline">
                  <div class="column is-full">
                    <admin-form-item>
                      <a href="https://analytics.naver.com/" target="_blank">
                        <div class="btn-link">Naver 애널리틱스 바로가기</div>
                      </a>
                    </admin-form-item>
                  </div>

                  <div class="column is-full">
                    <admin-form-item label="네이버 애널리틱스 분석 스크립트">
                      <textarea class="textarea"
                                rows="10"
                                cols="10"
                                maxlength="2000"
                                :value="value.social_key.naver.analytics"
                                @input="inputNaverAnalytics"></textarea>
                      <div class="desc">네이버 애널리틱스 분석 스크립트를 입력해주세요.</div>
                    </admin-form-item>
                  </div>
                </div>
              </admin-box-item>
            </div>
          </template>
          <!-- 카카오 -->
          <div v-else-if="selectedMenu==='kakao'" class="box">
            <admin-box-item title="카카오 계정 관리"
                            :useTab="false"
                            link="https://launchpack.notion.site/1725902f0f3a482aba234bd146d2e645">

              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item>
                    <a href="https://developers.kakao.com" target="_blank">
                      <div class="btn-link">Kakao Developers 바로가기</div>
                    </a>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="서비스에 적용할 API">
                    <div>
                      <lp-check-bool label="카카오 계정 로그인" v-if="isInternalPlugin('sns_signin')"
                                     :checkedVal.sync="value.social_key.kakao.enable.login"></lp-check-bool>
                    </div>
                    <div>
                      <lp-check-bool label="카카오톡, 카카오스토리 공유하기"
                                     :checkedVal.sync="value.social_key.kakao.enable.share"></lp-check-bool>
                    </div>
                    <!--<div>
                      <lp-check-bool label="지도" :checkedVal.sync="value.social_key.kakao.enable.map"></lp-check-bool>
                    </div>-->
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="Javascript 키">
                    <input class="input"
                           :value="value.social_key.kakao.javascript_key"
                           @input="e => value.social_key.kakao.javascript_key = e.target.value"
                           type="text" maxlength="50">
                    <div class="desc">설정 > 일반 > 기본정보 > 앱 키에서 Javascript 키를 복사해서 붙여 넣어주세요.</div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="REST API 키">
                    <input class="input"
                           :value="value.social_key.kakao.restapi_key"
                           @input="e => value.social_key.kakao.restapi_key = e.target.value"
                           type="text" maxlength="50">
                    <div class="desc">설정 > 일반 > 기본정보 > 앱 키에서 REST API 키를 복사해서 붙여 넣어주세요.</div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="Admin 키">
                    <input class="input"
                           :value="value.social_key.kakao.admin_key"
                           @input="e => value.social_key.kakao.admin_key = e.target.value"
                           type="text" maxlength="50">
                    <div class="desc">설정 > 일반 > 기본정보 > 앱 키에서 Admin 키를 복사해서 붙여 넣어주세요.</div>
                  </admin-form-item>
                </div>
                <div class="column is-full"  v-if="isInternalPlugin('sns_signin')">
                  <admin-form-item label="Redirect URL">
                    <input class="input"
                           :value="value.social_key.kakao.redirect_url"
                           @input="e => value.social_key.kakao.redirect_url = e.target.value"
                           type="text"
                           :disabled="true"
                           maxlength="50">
                    <div class="desc">플랫폼에 웹을 추가하고, Redirect Path에 위 주소를 붙여 넣어주세요.</div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="KakaoPay cid"
                                   desc="Admin 키와 KakaoPay cid를 추가하셨다면 서비스 설정 관리 > 결제 방식 설정에서 카카오 페이를 추가 선택 가능합니다.">
                    <input class="input"
                           :value="value.social_key.kakao.cid"
                           @input="e => value.social_key.kakao.cid = e.target.value"
                           type="text" maxlength="50">
                    <div class="desc">가맹점 코드. 10자</div>
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>
          <!-- 페이스북 -->
          <template v-else-if="selectedMenu==='facebook'">
            <div class="box">
              <admin-box-item title="페이스북 계정 관리"
                              :useTab="false" link="https://launchpack.notion.site/1725902f0f3a482aba234bd146d2e645">

                <div class="columns is-multiline">
                  <div class="column is-full">
                    <admin-form-item>
                      <a href="https://developers.facebook.com" target="_blank">
                        <div class="btn-link">facebook for Developers 바로가기</div>
                      </a>
                    </admin-form-item>
                  </div>
                  <div class="column is-full">
                    <admin-form-item label="서비스에 적용할 API">
                      <div>
                        <lp-check-bool label="페이스북 계정으로 로그인" v-if="isInternalPlugin('sns_signin')"
                                       :checkedVal.sync="value.social_key.facebook.enable.login"></lp-check-bool>
                      </div>
                      <div>
                        <lp-check-bool label="공유하기"
                                       :checkedVal.sync="value.social_key.facebook.enable.share"></lp-check-bool>
                      </div>
                    </admin-form-item>
                  </div>
                  <div class="column is-full">
                    <admin-form-item label="앱 ID">
                      <input class="input"
                             :value="value.social_key.facebook.client_id"
                             @input="e => value.social_key.facebook.client_id = e.target.value"
                             type="text" maxlength="50">
                      <div class="desc">설정 > 기본설정 > 앱 ID를 복사해서 붙여 넣어주세요.</div>
                    </admin-form-item>
                  </div>
                  <div class="column is-full">
                    <admin-form-item label="앱 시크릿 코드">
                      <input class="input"
                             :value="value.social_key.facebook.client_secret"
                             @input="e => value.social_key.facebook.client_secret = e.target.value"
                             type="text" maxlength="50">
                      <div class="desc">설정 > 기본설정 > 앱 시크릿 코드를 복사해서 붙여 넣어주세요.</div>
                    </admin-form-item>
                  </div>
                  <div class="column is-full"  v-if="isInternalPlugin('sns_signin')">
                    <admin-form-item label="유효한 OAuth 리디렉션 URI">
                      <input class="input"
                             :value="value.social_key.facebook.redirect_url"
                             @input="e => value.social_key.facebook.redirect_url = e.target.value"
                             type="text"
                             :disabled="true"
                             maxlength="50">
                      <div class="desc">제품 > facebook 로그인 > 설정 > 유효한 OAuth 리디렉션 URI에 위 주소를 붙여 넣어주세요.</div>
                    </admin-form-item>
                  </div>
                </div>
              </admin-box-item>
            </div>
            <div class="box">
              <admin-box-item title="페이스북 픽셀 관리" :useTab="false">
                <div class="columns is-multiline">
                  <div class="column is-full">
                    <admin-form-item label="픽셀 script">
                  <textarea class="textarea"
                            rows="10"
                            cols="10"
                            maxlength="2000"
                            :value="value.social_key.facebook.pixel_script"
                            @input="inputPixelScript"></textarea>
                      <div class="desc">Facebook Pixel script를 입력해주세요.</div>
                    </admin-form-item>
                  </div>
                </div>
              </admin-box-item>
            </div>
          </template>
          <!-- 구글 -->
          <template v-else-if="selectedMenu==='google'">
            <div class="box">
              <admin-box-item title="구글 계정 관리"
                              :useTab="false" link="https://launchpack.notion.site/1725902f0f3a482aba234bd146d2e645">

                <div class="columns is-multiline">
                  <div class="column is-full">
                    <admin-form-item label="적용할 서비스 선택">
                      <!--<div>
                        <lp-check-bool label="메일 발송 설정"
                                       :checkedVal.sync="value.social_key.google.enable.mail"></lp-check-bool>
                      </div>-->
                      <div>
                        <lp-check-bool label="애널리틱스"
                                       :checkedVal.sync="value.social_key.google.enable.ga"></lp-check-bool>
                      </div>
                      <div>
                        <lp-check-bool label="태그 관리자"
                                       :checkedVal.sync="value.social_key.google.enable.tag_manager"></lp-check-bool>
                      </div>
                      <div>
                        <lp-check-bool label="Firebase 클라우드 메시징"
                                       :checkedVal.sync="value.social_key.google.enable.firebase"></lp-check-bool>
                      </div>
                      <!--<div>
                        <lp-check-bool label="지도" :checkedVal.sync="value.social_key.google.enable.map"></lp-check-bool>
                      </div>-->
                    </admin-form-item>
                  </div>

                  <!--<template v-if="value.social_key.google.enable.mail">
                    <div class="column is-full">
                      <admin-form-item label="구글 계정(이메일주소)">
                        <input class="input"
                               :value="value.social_key.google.id"
                               @input="e => value.social_key.google.id = e.target.value"
                               placeholder="launchpack@gmail.com"
                               type="text" maxlength="50">
                        <div class="desc">
                          <b>메일발송 용도만으로 사용할 계정을 새로 만든 뒤 설정</b>하길 권장합니다.<br>
                          설정하시기 전에, Google 계정관리 > 보안 > 보안 수준이 낮은 앱의 액세스를 사용으로 설정해주세요.
                          <a style="color:#ff6600" href="https://support.google.com/accounts/answer/6010255?hl=ko" target="_blank">설정 참고 보러가기</a><br>
                        </div>
                      </admin-form-item>
                    </div>
                    <div class="column is-full">
                      <admin-form-item label="비밀번호">
                        <input class="input"
                               :value="value.social_key.google.password"
                               @input="e => value.social_key.google.password = e.target.value"
                               type="password" maxlength="50">
                        <div class="desc">이메일 발송에 사용할 구글 계정 비밀번호를 입력해주세요.</div>
                      </admin-form-item>
                    </div>
                    <div class="column is-full">
                    <admin-form-item label="테스트 메일 보내기">
                      <div class="btn-link" @click="sendEmail">테스트 메일 보내기</div>
                      <div class="desc">입력하신 구글 계정으로 메일 전송이 정상동작하는지 확인하기 위해, 메일 보내기 버튼을 눌러주세요.</div>
                    </admin-form-item>
                  </div>
                  </template>-->

                  <div v-if="value.social_key.google.enable.ga"
                       class="column is-full">
                    <admin-form-item label="애널리틱스 추적 ID">
                      <input class="input"
                             :value="value.social_key.google.ga"
                             @input="e => value.social_key.google.ga = e.target.value"
                             type="text" maxlength="50">
                      <div class="desc">구글 애널리틱스에서 추적 ID를 복사해서 붙여 넣어주세요.</div>
                      <a href="https://analytics.google.com/" target="_blank">
                        <div class="btn-link" style="margin-top:4px">구글 애널리틱스 바로가기</div>
                      </a>
                    </admin-form-item>
                  </div>

                  <div v-if="value.social_key.google.enable.map"
                       class="column is-full">
                    <admin-form-item label="Google Map API 키">
                      <input class="input"
                             :value="value.social_key.google.api_key"
                             @input="e => value.social_key.google.api_key = e.target.value"
                             type="text" maxlength="50">
                      <div class="desc">api 키를 복사해서 붙여 넣어주세요.</div>
                    </admin-form-item>
                  </div>
                  <div v-if="value.social_key.google.enable.firebase"
                       class="column is-full">
                    <admin-form-item label="Firebase 클라우드 메시징 서버키">
                      <input class="input"
                             :value="value.social_key.google.firebase"
                             @input="e => value.social_key.google.firebase = e.target.value"
                             type="text" maxlength="200">
                      <div class="desc">Firebase 설정 > 클라우드 메시징에서 서버 키를 복사해서 붙여 넣어주세요.</div>
                      <a href="https://firebase.google.com/?hl=ko" target="_blank">
                        <div class="btn-link" style="margin-top:4px">Firebase 바로가기</div>
                      </a>
                    </admin-form-item>
                  </div>

                  <div v-if="value.social_key.google.enable.tag_manager"
                       class="column is-full">
                    <admin-form-item label="태그 관리자">
                      <textarea class="textarea"
                                rows="10"
                                cols="10"
                                maxlength="2000"
                                :value="value.social_key.google.tag_manager.head"
                                @input="e=>inputTagManaerScript(e, 'head')"></textarea>
                      <div class="desc">{{ tag_manager_head_desc }}</div>
                      <textarea class="textarea"
                                style="margin-top:32px"
                                rows="10"
                                cols="10"
                                maxlength="2000"
                                :value="value.social_key.google.tag_manager.body"
                                @input="e=>inputTagManaerScript(e, 'body')"></textarea>
                      <div class="desc">{{ tag_manager_body_desc }}</div>
                    </admin-form-item>
                  </div>
                </div>
              </admin-box-item>
            </div>
             <div class="box">
              <admin-box-item title="이메일 계정 관리" :useTab="false"
                              link="https://launchpack.notion.site/1725902f0f3a482aba234bd146d2e645">
                <div class="columns is-multiline">
                  <div class="column is-full">
                    <admin-form-item label="계정 메일 주소">
                      <input class="input"
                             :value="value.social_key.email.id"
                             @input="e => value.social_key.email.id = e.target.value"
                             type="text" maxlength="50">
                      <div class="desc">사용하실 이메일 계정을 입력하세요.
                        최초에 이메일을 저장하시고 난 후, 옆에 이메일 인증하기 버튼을 클릭하시면 이메일 계정 확인을 위해 입력하신 계정으로 메일이 전송됩니다.
                        확인절차가 끝나고 나면 이메일 발송을 이용할 수 있습니다.
                      </div>
                      <div style="margin-top:12px">
                        <div class="btn-link" style="margin-right:12px" v-if="value.social_key.email.id.indexOf('@')>-1" @click="verifyEmail">
                          이메일 인증하기
                        </div>
                        <!--<div class="btn-link" v-if="button.email_verify" @click="testEmail">테스트 메일 보내기</div>-->
                      </div>
                    </admin-form-item>
                  </div>
                </div>
              </admin-box-item>
            </div>
          </template>
          <!-- 애플 -->
          <div v-else-if="selectedMenu==='apple'" class="box">
            <admin-box-item title="애플 계정 관리"
                            subtitle="apple developer에 접속 후 Account 메뉴 > Certificates, Identifiers & Profiles를 설정하세요."
                            :useTab="false"
                            link="https://launchpack.notion.site/1725902f0f3a482aba234bd146d2e645">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item>
                    <a href="https://developer.apple.com" target="_blank">
                      <div class="btn-link">apple for Developers 바로가기</div>
                    </a>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="서비스에 적용할 API">
                    <div>
                      <lp-check-bool label="애플 계정으로 로그인"
                                     :checkedVal.sync="value.social_key.apple.enable.login"></lp-check-bool>
                    </div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="client_id">
                    <input class="input"
                           :value="value.social_key.apple.client_id"
                           @input="e => value.social_key.apple.client_id = e.target.value"
                           type="text" maxlength="50">
                    <div class="desc">Identifiers > Services ID > Bundle ID를 복사해서 붙여 넣어주세요.</div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="redirect_url">
                    <input class="input"
                           :value="value.social_key.apple.redirect_url"
                           @input="e => value.social_key.apple.redirect_url = e.target.value"
                           type="text"
                           :disabled="true"
                           maxlength="50">
                    <div class="desc">Identifiers > Services ID > Sign In with Apple의 configure에서 Website Urls에 추가한
                      redirect_uri를 복사해서 붙여 넣어주세요.
                    </div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="social_auth_apple_key_id">
                    <input class="input"
                           :value="value.social_key.apple.social_auth_apple_key_id"
                           @input="e => value.social_key.apple.social_auth_apple_key_id = e.target.value"
                           type="text" maxlength="50">
                    <div class="desc">Keys > 생성한 Key ID를 복사해서 붙여 넣어주세요.</div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="social_auth_apple_team_id">
                    <input class="input"
                           :value="value.social_key.apple.social_auth_apple_team_id"
                           @input="e => value.social_key.apple.social_auth_apple_team_id = e.target.value"
                           type="text" maxlength="50">
                    <div class="desc">Identifiers > App ID > Team ID를 복사해서 붙여 넣어주세요.</div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="social_auth_apple_private_key">
                    <input-single-file :value.sync="value.social_key.apple.social_auth_apple_private_key_ext"
                                       :acceptExt="'.p8'"
                                       description=""
                                       :maxLength="1"
                                       @setValue="val=>value.social_key.apple.social_auth_apple_private_key=val"></input-single-file>
                    <div class="desc">Keys > 생성한 Key의 다운로드 파일을 첨부해주세요.</div>
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>
          <!-- AWS -->
          <div v-else-if="selectedMenu==='aws'" class="box">
            <admin-box-item title="AWS 계정 관리"
                            :useTab="false">

              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="ACCESS KEY ID">
                    <input class="input"
                           :value="value.social_key.aws.access_key_id"
                           @input="e => value.social_key.aws.access_key_id = e.target.value"
                           type="text" maxlength="50">
                    <div class="desc">aws iam > 사용자 추가 또는 기존 사용자 > 액세스 키 아이디를 넣어주세요.</div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="SECRET ACCESS KEY">
                    <input class="input"
                           :value="value.social_key.aws.secret_access_key"
                           @input="e => value.social_key.aws.secret_access_key = e.target.value"
                           type="text" maxlength="50">
                    <div class="desc">aws iam > 사용자 추가 또는 기존 사용자 > 시크릿 액세스 키를 넣어주세요.</div>
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>
          <!-- 문자전송 -->
          <div v-else-if="selectedMenu==='sms'" class="box">
            <admin-box-item title="문자전송 서비스 계정 관리" :useTab="false">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="COOL_APIKEY">
                    <input class="input"
                           :value="value.social_key.sms.api_key"
                           @input="e => value.social_key.sms.api_key = e.target.value"
                           type="text" maxlength="50">
                    <div class="desc">COOL SMS 계정 api key를 입력해주세요.</div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="COOL_SECRET">
                    <input class="input"
                           :value="value.social_key.sms.secret_key"
                           @input="e => value.social_key.sms.secret_key = e.target.value"
                           type="text" maxlength="50">
                    <div class="desc">COOL SMS 계정 secret key를 입력해주세요.</div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="발신번호">
                    <input class="input"
                           :value="value.social_key.sms.from_phone"
                           @input="e => value.social_key.sms.from_phone = e.target.value"
                           type="text" maxlength="50">
                    <div class="desc">COOL SMS에서 사용하는 발신번호를 입력해주세요.</div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <div class="btn-link" @click="clickMsgTemp">메세지 템플릿 관리</div>
                  <!--                  <div class="btn-link" @click="$router.push(getPath('sms_message_template'))">메세지 템플릿 관리</div>-->
                </div>
              </div>
            </admin-box-item>
          </div>
          <!-- 이니시스 -->
          <div v-else-if="selectedMenu==='inicis'" class="box">
            <admin-box-item title="KG 이니시스 계정 관리" :useTab="false">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="mid">
                    <input class="input"
                           :value="value.social_key.inicis.mid"
                           @input="e => value.social_key.inicis.mid = e.target.value"
                           type="text" maxlength="50">
                    <div class="desc">KG 이니시스 계정 mid를 입력해주세요. 관리자 로그인 후 상단 메뉴 상점정보>계약정보>기본정보 메뉴로 이동 합니다. 기본 정보 화면의 상점
                      ID를 입력하세요.
                    </div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="signKey">
                    <input class="input"
                           :value="value.social_key.inicis.sign_key"
                           @input="e => value.social_key.inicis.sign_key = e.target.value"
                           type="text" maxlength="50">
                    <div class="desc">KG 이니시스 계정 signKey를 입력해주세요. 관리자 로그인 후 상단 메뉴 상점정보>계약정보>부가정보 메뉴로 이동 합니다. 부가 정보 화면의 웹
                      결제 Signkey를 입력하세요.
                    </div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="가상계좌 입금내역통보URL">
                    <input class="input"
                           :value="`https://plugin.launchpack.co.kr/php/vacct/deposit_notification.php?service_key=${$store.getters.getServiceSetting.service_key}`"
                           type="text"
                           :disabled="true"
                           maxlength="50">
                    <div class="desc">KG 이니시스 관리자페이지 접속 후 거래내역>가상계좌>입금통보방식선택 페이지에서 입금내역통보URL에 붙여넣어주세요.</div>
                  </admin-form-item>
                </div>
                <!--<div class="column is-full">
                  <admin-form-item label="INIAPI KEY">
                    <input class="input"
                           :value="value.social_key.inicis.iniapi_key"
                           @input="e => value.social_key.inicis.iniapi_key = e.target.value"
                           type="text" maxlength="50">
                    <div class="desc">KG 이니시스 계정 INIAPI KEY를 입력해주세요. 관리자 로그인 후 상단 메뉴 상점정보>계약정보>부가정보 메뉴로 이동 합니다. 부가 정보 화면의 INIAPI Key 생성 갱신을 선택후 생성된 KEY값을 붙여넣어주세요.</div>
                  </admin-form-item>
                  <admin-form-item label="INIAPI IV">
                    <input class="input"
                           :value="value.social_key.inicis.iniapi_iv"
                           @input="e => value.social_key.inicis.iniapi_iv = e.target.value"
                           type="text" maxlength="50">
                    <div class="desc">KG 이니시스 계정 INIAPI IV를 입력해주세요. 관리자 로그인 후 상단 메뉴 상점정보>계약정보>부가정보 메뉴로 이동 합니다. 부가 정보 화면의 INIAPI Key 생성 갱신을 선택후 생성된 IV값을 붙여넣어주세요.</div>
                  </admin-form-item>
                </div>-->
              </div>
            </admin-box-item>
          </div>
          <!-- Channel IO -->
          <div v-else-if="selectedMenu==='channel_io'" class="box">
            <admin-box-item title="Channel IO" :useTab="false">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="script">
                     <textarea class="textarea"
                               rows="10"
                               cols="10"
                               maxlength="2000"
                               :value="value.social_key.channel.plugin_script"
                               @input="inputScript"></textarea>
                    <div class="desc">Channel io plugin script를 입력해주세요. 채널 설정 > 플러그인 설정 > 채팅 설치 및 설정 > 플러그인 설치
                      로 이동합니다.
                    </div>
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>
          <!-- 가상번호 -->
          <div v-else-if="selectedMenu==='eney'" class="box">
            <admin-box-item title="가상번호 서비스 계정 관리"
                            :useTab="false">

              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item>
                    <a href="https://www.eney.co.kr/build/index.html#!/main" target="_blank">
                      <div class="btn-link">eney 서비스 페이 바로가기</div>
                    </a>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="서비스에 적용할 API">
                    <div>
                      <lp-check-bool label="050 가상번호"
                                     :checkedVal.sync="value.social_key.eney.enable.service"></lp-check-bool>
                    </div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="에네이 ID">
                    <input class="input"
                           :value="value.social_key.eney.id"
                           @input="e => value.social_key.eney.id = e.target.value"
                           type="text" maxlength="50">
                    <div class="desc">에네이 계정 ID를 입력해주세요.</div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="API 토큰">
                    <input class="input"
                           :value="value.social_key.eney.token"
                           @input="e => value.social_key.eney.token = e.target.value"
                           type="text" maxlength="50">
                    <div class="desc">마이에네이 > 서비스페이지 > 개발자센터 > TOKEN > API KEYS 를 복사해서 붙여 넣어주세요.</div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="가상번호 등록">
                    <input type="file" id="file"
                           ref="files"
                           @change="handleFileUpload"
                           :accept="acceptExt">
                    <div>
                      <div class="btn-link"><label for="file">050번호 추가하기</label></div>
                      <span class="desc">&nbsp;등록된 번호 수: {{ regCallCount }}</span>
                    </div>
                    <div class="desc">마이에네이 > 서비스페이지 > 패치 > 엑셀 다운로드 로 받은 파일로 선택해주세요.</div>
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>
          <!-- 본인인증 -->
          <template v-else-if="selectedMenu==='verify'">
            <div class="box" v-if="isInternalPlugin('identity_verify')">
              <admin-box-item title="모빌리언스 본인확인 서비스 관리"
                              :useTab="false">

                <div class="columns is-multiline">
                  <div class="column is-full">
                    <admin-form-item label="본인확인 서비스 사용">
                      <div>
                        <lp-check-bool label="사용"
                                       :checkedVal.sync="value.social_key.mobilians_certify.enable.service"></lp-check-bool>
                      </div>
                    </admin-form-item>
                  </div>
                  <div class="column is-full">
                    <admin-form-item label="서비스 ID">
                      <input class="input"
                             :value="value.social_key.mobilians_certify.svcid"
                             @input="e => value.social_key.mobilians_certify.svcid = e.target.value"
                             type="text" maxlength="50">
                      <div class="desc">모빌리언스에서 발급받은 서비스ID 를 입력해주세요.</div>
                    </admin-form-item>
                  </div>
                </div>
              </admin-box-item>
            </div>
            <div class="box" v-if="isInternalPlugin('nice_identity_verify') || isInternalPlugin('age_verify')">
              <admin-box-item title="나이스 본인확인 서비스 관리"
                              :useTab="false">
                <div class="columns is-multiline">
                  <div class="column is-full">
                    <admin-form-item label="본인확인 서비스 사용" desc="NICE평가정보와 계약 후 전달 받은 사이트 코드, 패스워드를 입력해주세요.">
                      <a slot="button" target="_blank" href="https://www.niceid.co.kr/serv_aply.nc">
                        <button slot="button" class="button text-primary" style="width: auto">NICE아이디 서비스 계약하기</button>
                      </a>
                      <lp-check-bool label="사용"
                                     :checkedVal.sync="value.social_key.nice.enable.service"></lp-check-bool>
                    </admin-form-item>
                    <admin-form-item label="사이트 코드" style="margin-top:12px">
                      <input class="input"
                             placeholder="NICE 평가정보와 계약 후 전달 받은 사이트 코드를 입력해주세요."
                             :value="value.social_key.nice.sitecode"
                             @input="e => value.social_key.nice.sitecode = e.target.value"
                             type="text" maxlength="50">
                    </admin-form-item>
                    <admin-form-item label="사이트 패스워드" style="margin-top:12px">
                      <input class="input"
                             placeholder="NICE 평가정보와 계약 후 전달 받은 사이트 패스워드를 입력해주세요."
                             :value="value.social_key.nice.sitepasswd"
                             @input="e => value.social_key.nice.sitepasswd = e.target.value"
                             type="text" maxlength="50">
                    </admin-form-item>
                  </div>
                </div>
              </admin-box-item>
            </div>
          </template>
        </div>
      </div>
    </div>

    <modal name="alertModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item :title="alert.title" :useTab="false" class="lp-modal-wrapper">
        <div style="white-space: pre-line">{{ alert.content  }}
          <template v-if="alert.fail">
            <a style="color:#ff6600" href="https://support.google.com/accounts/answer/6010255?hl=ko" target="_blank">설정 참고 보러가기</a>
          </template>
        </div>
        <div class="btn-group-justify-end" style="margin-top:24px">
          <button class="button is-primary" @click="$modal.hide('alertModal')">확인</button>
        </div>
      </admin-box-item>
    </modal>
  </div>
</template>

<script>
  import InputImg from '../../module/common/InputImg'
  import LpInputText from '../../module/common/LpInputText'
  import LpAddress from '../../module/common/LpAddress'
  import LpCheckBool from "../../module/common/LpCheckBool";
  import AdminFormItem from "../../module/admin/AdminFormItem";
  import LpRadio from "../../module/common/LpRadio";
  import LpCheckGroup from "../../module/common/LpCheckGroup";
  import InputFile from "../../module/common/InputFile";
  import InputSingleFile from "../../module/common/InputSingleFile";

  export default {
    layout: 'Main',
    name: 'APISetting',
    components: {
      InputSingleFile,
      InputFile,
      LpCheckGroup,
      LpRadio,
      AdminFormItem,
      LpCheckBool,

      InputImg,
      LpInputText,
      LpAddress
    },
    created() {
      this.getData();

      if (!this.isLaunchpack) {
        this.$axios.get('admin/service/virtualcall/regist/count')
          .then(res => {
            this.regCallCount = res.data.detail;
          })
          .catch(error => {
            //console.log(error);
          })
      }
    },
    data() {
      return {
        selectedMenu: 'naver',
        menu: [
          {
            label: '네이버',
            value: 'naver'
          },
          {
            label: '카카오',
            value: 'kakao'
          },
          {
            label: '페이스북',
            value: 'facebook'
          },
          {
            label: '구글',
            value: 'google'
          },
          /* {
            label: '이메일',
            value: 'google'
          }, */
          {
            label: '애플',
            value: 'apple'
          },
          {
            label: '아마존웹서비스',
            value: 'aws'
          },
          {
            label: '문자 전송 서비스',
            value: 'sms'
          },
          {
            label: 'KG이니시스',
            value: 'inicis'
          }
        ],
        tag_manager_head_desc: '페이지의 <head>에 들어갈 코드입니다.',
        tag_manager_body_desc: '페이지의 <body> 태그 뒤에 들어갈 코드입니다.',
        value: {},
        button: {
          email_verify: false
        },
        acceptExt: '.xlsx',
        file: undefined,
        regCallCount: 0,
        payTypeArr: [
          {label: '신용카드', value: 0},
          {label: '휴대폰 결제', value: 1}
        ],
        alert: {
          title: '',
          content: '',
          fail: false
        },
        // uploadReady: true
      }
    },
    methods: {
      clickMsgTemp() {
        let url = this.getPath('sms_message_template');
        // 가람 서비스 예외처리
        if(location.href.indexOf('https://garam')>-1) {
          url = this.getPath('service/kakao_message_template');
        }
        this.routerPush(url);
      },
      verifyEmail() {
        this.$axios.post('admin/service/social_key/email/verify').then(res => {
          if (res.status === 200) {
            this.toast('입력하신 이메일로 계정 인증 링크를 보냈습니다.')
            this.button.email_verify = true;
          }
        })
      },
      getData() {
        this.$axios.get('admin/service/social_key')
          .then(res => {
            if (res.status === 200) {
              this.value = this.initData(res.data);
              this.setMenu();
            }
          });
      },
      inputNaverAnalytics(e) {
        this.value.social_key.naver.analytics = e.target.value.replace(/"/g, "'");
      },
      inputTagManaerScript(e, type) {
        this.value.social_key.google.tag_manager[type] = e.target.value.replace(/"/g, "'");
      },
      inputPixelScript(e) {
        this.value.social_key.facebook.pixel_script = e.target.value.replace(/"/g, "'");
      },
      // input channel io script
      inputScript(e) {
        this.value.social_key.channel.plugin_script = e.target.value.replace(/"/g, "'");
      },
      setMenu() {
        if (this.isInternalPlugin('age_verify') || this.isInternalPlugin('identity_verify') || this.isInternalPlugin('nice_identity_verify')) {
          this.menu.push({
            label: '본인확인 서비스',
            value: 'verify'
          })
        }
        if (this.isInternalPlugin('channel')) {
          this.menu.push({
            label: '채널IO',
            value: 'channel_io'
          })
        }
        if (this.isPackage('call')) {
          this.menu.push({
            label: '가상번호 서비스',
            value: 'eney'
          },);
        }
        if (!this.isInternalPlugin('sns_signin')) {
          this.menu.splice(this.menu.findIndex(i=>{ return i.value === 'apple' }),1);
        }

        if(this.$route.query.menu) {
          this.selectedMenu = this.$route.query.menu;

          // 본인확인 서비스 이용시, 사용에 체크후 자동 저장
          if(this.$route.query.menu === 'verify') {
            this.value.social_key.nice.enable.service = true;
            this.$axios.post('admin/service/social_key', this.value)
          }
        }
      },
      initData(data) {
        if (data.social_key.google.enable.firebase === undefined) {
          data.social_key.google.enable.firebase = false;
          data.social_key.google.firebase = '';
        }

        if (data.social_key.google.enable.tag_manager === undefined) {
          data.social_key.google.enable.tag_manager = false;
          data.social_key.google.tag_manager = {
            head: '',
            body: ''
          }
        }

        if (data.social_key.sms.from_phone === undefined) {
          data.social_key.sms.from_phone = ''
        }

        if (data.social_key.aws === undefined) {
          data.social_key.aws = {
            access_key_id: '',
            secret_access_key: ''
          }
        }

        if (data.social_key.sms === undefined) {
          data.social_key.sms = {
            api_key: '',
            secret_key: ''
          }
        }

        if (data.social_key.inicis === undefined) {
          data.social_key.inicis = {
            mid: '',
            sign_key: '',
            iniapi_key: '',
            iniapi_iv: ''
          }
        }

        if (data.social_key.inicis) {
          if (!data.social_key.inicis.iniapi_key) {
            data.social_key.inicis.iniapi_key = '';
          }
          if (!data.social_key.inicis.iniapi_iv) {
            data.social_key.inicis.iniapi_iv = '';
          }
        }

        if (!data.social_key.channel) {
          data.social_key.channel = {
            plugin_script: ''
          }
        }

        if (!data.social_key.apple) {
          data.social_key.apple = {
            enable: {
              login: false
            },
            social_auth_apple_key_id: "",
            social_auth_apple_team_id: "",
            social_auth_apple_private_key: "",
            social_auth_apple_private_key_ext: '',
            client_id: "",
            redirect_url: ""
          }
        }

        if (!data.social_key.nice) {
          data.social_key.nice = {
            enable: {
              service: false
            },
            sitecode: '',
            sitepasswd: ''
          }
        }
        if (!data.social_key.naver.verification) {
          data.social_key.naver.verification = '';
        }
        if (!data.social_key.naver.analytics) {
          data.social_key.naver.analytics = '';
        }
        if (!data.social_key.email) {
          data.social_key.email = {
            id: ''
          };
        }

        data.social_key.kakao.redirect_url = this.fullRedirectUrl('kakao');
        data.social_key.facebook.redirect_url = this.fullRedirectUrl('facebook');
        data.social_key.naver.redirect_url = this.fullRedirectUrl('naver');

        return data;
      },
      isPackage(name) {
        let packs = this.$store.getters.getServiceSetting.packages;
        if (packs && packs.indexOf(name) > -1) return true;
      },
      // 수수료 체크박스 선택 확인
      isCheck(type) {
        if (type === 'credit') {
          if (this.value.social_key.pg.pay_checklist.indexOf(0) > -1) return true;
          else return false;
        } else if (type === 'phone') {
          if (this.value.social_key.pg.pay_checklist.indexOf(1) > -1) return true;
          else return false;
        }
      },
      sendEmail() {
        let id = this.value.social_key.google.id;
        let password = this.value.social_key.google.password;
        if (!id || !password) {
          this.toast('아이디나 패스워드를 입력하세요.');
          return;
        }
        let param = {
          id: id,
          password: password
        }
        this.$store.commit('setLoading', true);
        this.$axios.post('admin/service/test/email', param).then(res => {
          this.$store.commit('setLoading', false);
          if (res.status === 200) {
            this.alert.title = '테스트 메일 보내기 성공';
            this.alert.content = '테스트 메일이 정상적으로 발송되었습니다.';
            this.alert.fail = false;
            this.$modal.show('alertModal');
          }
        }).catch(error => {
          this.$store.commit('setLoading', false);
          if (error.response) {
            this.alert.title = '테스트 메일 보내기 실패';
            this.alert.content = '아이디, 비밀번호가 잘못되었거나\n필요한 보안 설정이 되어 있지 않습니다.\n\n' +
              "* 필요한 보안 설정 방법\nGoogle 계정관리 > 보안 > 보안 수준이 낮은 앱의 액세스를 '사용'으로 설정";
            this.alert.fail = true;
            this.$modal.show('alertModal');
          }
        })
      },
      fullRedirectUrl(service_type) {
        if (service_type === 'naver') {
          return this.$store.getters.getServiceSetting.domain + '/signin/' + service_type;
        } else {
          return this.$store.getters.getServiceSetting.domain + '/api/auth/user/signin/' + service_type;
        }
      },
      valid() {
        let result = true;
        let msg = '';
        if(this.selectedMenu === 'google' && this.value.social_key.email.id.indexOf('@') > -1
          && !this.button.email_verify) {
          result = false;
          msg = '이메일 인증하기 버튼을 클릭해주세요.';
        }
        if(this.selectedMenu === 'sms') {
          if(this.value.social_key.sms.api_key === '') {
            result = false;
            msg = 'COOL_APIKEY를 입력해주세요.';
          } else if(this.value.social_key.sms.secret_key === '') {
            result = false;
            msg = 'COOL_SECRET을 입력해주세요.';
          } else if(this.value.social_key.sms.from_phone === '') {
            result = false;
            msg = '발신번호를 입력해주세요.';
          }
        }
        if(this.selectedMenu === 'verify' && this.value.social_key.nice.enable.service) {

          if(this.value.social_key.nice.sitecode === '') {
            result = false;
            msg = '사이트 코드를 입력해주세요.';
          } else if(this.value.social_key.nice.sitepasswd === '') {
            result = false;
            msg = '사이트 패스워드를 입력해주세요.';
          }
        }

        if(msg!=='') {
          this.toast(msg);
        }

        return result;
      },
      save() {
        if(this.valid()) {
          this.$axios.post('admin/service/social_key', this.value)
            .then(res => {
              if (res.status === 200) {
                this.toast('저장되었습니다.');
                this.getData();

                if(this.selectedMenu === 'google' && this.button.email_verify) {
                  this.saveServiceGuide('email');
                }
                else if(this.selectedMenu === 'naver' && this.value.social_key.naver.enable.map) {
                  this.saveServiceGuide('map');
                }
                else if(this.selectedMenu === 'sms') {
                  this.saveServiceGuide('sms');
                }
                else if(this.selectedMenu === 'verify' && this.value.social_key.nice.enable.service) {
                  this.$axios.post('admin/service/guide/save', {
                    names: ['nice_indentify_verify', 'age_verify']
                  })
                }

                this.$store.commit('setBackendData', {social_key: this.value.social_key});
              }
            });
        }
      },

      handleFileUpload() {
        this.file = this.$refs.files.files[0];

        if (this.file.size > 115343360) {
          this.toast('최대 10MB 파일까지만 업로드 가능합니다.');
          return;
        }

        this.regCall();
      },

      regCall() {
        let formData = new FormData();

        formData.append('file', this.file);

        this.$axios.post('admin/service/virtualcall/regist', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(res => {
            if (res.status === 200) {
              this.toast(`${res.data.detail} 개의 번호가 등록되었습니다.`);
              this.$refs.files.value = "";
            }
          })
          .catch(error => {
            //console.log(error);
            this.toast('등록된 형식의 문서가 아닙니다.');
            this.$refs.files.value = "";
          });

        // 등록된 전화번호 수
        this.$axios.get('admin/service/virtualcall/regist/count')
          .then(res => {
            this.regCallCount = res.data.detail;
          })
          .catch(error => {
            //console.log(error);
          })
      },

    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  //@import '~assets/css/lp_main'
  select
    border-radius 4px
    padding 6px 20px
    border 1px solid #dddddd
    margin-top 4px

  .btn-link
    border 1px solid #008fd9
    padding 4px 8px
    border-radius 3px
    font-size 0.7rem
    color: #008fd9
    display inline-block

  .btn-link:hover
    cursor pointer
    background-color #008fd9
    color #ffffff

  .desc
    font-size 0.8rem
    margin-top 4px
    color #787878

  #file
    position fixed
    bottom -100px
    left -100px

</style>
